import { render } from "./SelectStudentsForm.vue?vue&type=template&id=4226d8ac&scoped=true"
import script from "./SelectStudentsForm.vue?vue&type=script&lang=js"
export * from "./SelectStudentsForm.vue?vue&type=script&lang=js"

import "./SelectStudentsForm.vue?vue&type=style&index=0&id=4226d8ac&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4226d8ac"]])

export default __exports__